import React from "react";
import { Navigate, Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import LoginPage from "../pages/login/index";
import ForgotPassword from "../pages/forgot-password";
import RateCard from "../pages/rate-card";
import ZipZone from "../pages/zip-zone";
import Carrier from "../pages/carrier";
import PortLookup from "../pages/port-lookup";
import RateLookup from "../pages/rate-lookup";
import Simulation from "../pages/simulation";
import ServiceManagement from "../pages/carrier-service-managemnet";
import Port from "../pages/port";
import Client from "../pages/client";
import Product from "../pages/Product";
import DemandProfile from "../pages/DemandProfile";
import OrderManagement from "../pages/order-management";
import Shipment from "../pages/shipment";
import ShipmentOptions from "../pages/shipment-options";
import WeightPackage from "../pages/package-mapping";
import ShippingCost from "../pages/shipping-cost";
import OrderTracking from "../pages/track-order";
import OrderTrackingHistory from "../pages/order-tracking-history";
import ForeCast from "../pages/forecast";
import Transaction from "../pages/transaction";
import Partner from "../pages/partner";
import CustomClearance from "../pages/custom-clearance";
import CustomProvider from "../pages/custom-provider";
import FreightBroker from "../pages/frieght-broker";
import Supplier from "../pages/supplier";
import ImportProduct from "../pages/import-product";
import OnBoardLogin from "../pages/onboard-login";
import AccountSettings from "../pages/account-setting";
import AlertsAndNotification from "../pages/alerts-and-notifications";
import Billing from "../pages/billing";
import EmailTemplateScreen from "../pages/email-template";
import ManagePO from "../pages/manage-po";
import ManageProduct from "../pages/manage-product";
import GlobalNetworkDesign from "../pages/global-network-design";
import Provider from "../pages/provider";
import ProviderEventMapping from "../pages/provider-event-mapping";
import OrderWorkFlow from "../pages/order-flow";
import TrackingEvents from "../pages/tracking-event";
import Events from "../pages/events";
import Rules from "../pages/rules";
import AssignUser from "../pages/assign-user";
import Sidemenu from "../pages/sidemenu";
import RoleSidemenu from "../pages/role-sidemenu";
import Manifest from "../pages/manifest";
import Overpack from "../pages/overpack";
import Shipments from "../pages/shipments";
import ReturnsPage from "../pages/returns";
import TransferOrdersPage from "../pages/transfer-orders";
import ShopifyAppConfig from "../pages/shopify-app-config";
import Pipe17Onboard from "../pages/pipe17-onboard";
import ClientOnboard from "../pages/client-onboard";
import ShippingServiceMap from "../pages/shipping-service-map";
import ShippingService from "../pages/shipping-service";
import UpdateASNForm from "../pages/update-asn";
import CreatePurchaseOrder from "../pages/create-purchase-order";
import Inventory from "../pages/inventory";
import HistoricalInventory from "../pages/historical-inventory";
import PurchaseOrder from "../pages/purchase-order";
import AsnTrackingHistory from "../pages/asn-tracking";
import OrderImport from "../pages/order-import";
import MasterPurchaseOrder from "../pages/master-purchase-order";
import SupplierClientMap from "../pages/supplier-client-map";
import DropSkipTools from "../pages/market-data";
import ManageMarketData from "../pages/manage-market-data";
import MarketDataCalculation from "../pages/market-data-calculation";
import ManualTracking from "../pages/manual-tracking";
import Kaman from "../pages/ask-dropskip";
import ProductImport from "../pages/product-import";
import SupplierImport from "../pages/supplier-import";
import SupplierConfigImport from "../pages/supplier-config-import";
import PurchaseOrderImport from "../pages/purchase-order-import";
import MasterPurchaseOrderImport from "../pages/master-purchase-order-import";
import InventoryImport from "../pages/inventory-import";
import HistoricalInventoryImport from "../pages/historical-inventory-import";
import HistoricalInventorySnapshotHealth from "../pages/historical-inventory-snapshot-health";
import ArchiveOrder from "../pages/historical-order";
import ManagePayment from "../pages/manage-payment";
import BillingTransaction from "../pages/billing-transaction";
import OriginZone from "../pages/zone";
import ZoneChart from "../pages/zone-chart";
import ClientConfig from "../pages/client-config";
import OAuthClient from "../pages/o-auth-client";
import AddM2O from "../pages/create-m2o-order";
import M2oOrderTrackingHistory from "../pages/m2o-order-track";
import Users from "../pages/users";
import CreateOrder from "../pages/create-order";
import AccessLog from "../pages/access-log";
import KafkaDeadLetter from "../pages/kafka-dead-letter";
import Roles from "../pages/roles";
import InventoryConfigModal from "../pages/inventory-config";
import Dashboard from "../pages/rl-dashboard";
import DashboardLandingPage from "../pages/dashboard-landing";
import Country from "../pages/country";
import Province from "../pages/province";
import Estimator from "../pages/estimator";
import HistoricalShipments from "../pages/historical-shipments";
import ShipmentImport from "../pages/shipment-import";
import HistoricalDataImport from "../pages/historical-data-import";
import NetworkDesign from "../pages/network-design";
import ManageNetworkDesign from "../pages/manage-network-design";
import ViewNetworkDesign from "../pages/view-network-design";
import ClientNetworkDesign from "../pages/client-network-design";
import FullyLandedCalculator from "../pages/fully-landed-calculator";
import ForecastParameter from "../pages/forecast-parameter";
import ParameterValue from "../pages/parameter-value";
import ParameterValueImport from "../pages/parameter-value-import";
import ProfileAssumptions from "../pages/ProfileAssumption";
import StaticAssumption from "../pages/StaticAssumption";
import DemandCalculation from "../pages/DemandCalculation";
import Kanban from "../pages/kanban";
import AdminConfig from "../pages/admin-config";
import AgentConfig from "../pages/agent-config";
import Catalog from "../pages/catalog";
import ManageCatalog from "../pages/manage-catalog";
import CatalogImport from "../pages/catalog-import";
import GeneratedSalesCart from "../pages/generated-sales-cart";
import Customer from "../pages/customer";
import Category from "../pages/category";
import SalesByCategory from "../pages/sales-by-category";
import Agent from "../pages/agent";
import SalesByCategoryImport from "../pages/sales-by-category-import";
import CatalogPlanner from "../pages/catalog-planner";
import CatalogPlans from "../pages/catalog-plans";
import CatalogPlanForecast from "../pages/catalog-planner-forecast";
import FulfillmentRule from "../pages/fulfillment-rule";
import MetricsPage from "../pages/metrics";
import SalesHistoryPage from "../pages/sales-history";
import LateShipPage from "../pages/late-ship";
import PlanningForecast from "../pages/planning-forecast";
import PlanningForecastNew from "../pages/planning-forecast-new";
import LostSalesAnalysisPage from "../pages/lost-sales-analysis";
import ReturnsAnalysisPage from "../pages/returns-analysis";
import OrderChannelReviewPage from "../pages/order-channel-review";
import InventoryAnalysisPage from "../pages/inventory-analysis";
import InventoryHealthPage from "../pages/inventory-health";
import InventoryRiskPage from "../pages/inventory-risk";
import PurchaseOrderAnalysisPage from "../pages/purchase-order-analysis";
import CommandCenterPage from "../pages/command-center";
import SupplyChainCostAnalysisPage from "../pages/supply-chain-cost-analysis";
import PrivacyPolicy from "../pages/privacy";

export default function AppRoutes() {
  return (
    <>
      <Route element={<ProtectedRoute />}>
        <Route element={<Product />} path="/product" />
        <Route element={<DemandProfile />} path="/demand-profile" />
        <Route element={<ProfileAssumptions />} path="/profile-assumptions" />
        <Route element={<StaticAssumption />} path="/static-assumptions" />
        <Route element={<DemandCalculation />} path="/demand-calculation" />
        <Route element={<CommandCenterPage />} path="/" />
        {/* The previous stage board, kept reachable while the Command Center replaces it. */}
        <Route element={<Kanban />} path="/supply-flow" />
        <Route element={<DashboardLandingPage />} path="/insight" />
        <Route element={<MetricsPage />} path="/sales-analysis" />
        <Route element={<SalesHistoryPage />} path="/sales-history" />
        <Route element={<PlanningForecast />} path="planning-forecast" />
        {/* Clients' Forecast page: the Updated Forecast (demand-forecast
            engine) for their own account. */}
        <Route
          element={<PlanningForecastNew key="client-updated" variant="updated" />}
          path="/planning-forecast-new"
        />
        {/* Admins: Inventory → Updated Forecast, with a client picker. */}
        <Route
          element={<PlanningForecastNew key="updated" variant="updated" />}
          path="/updated-forecast"
        />
        <Route
          element={<Navigate to="/sales-analysis" replace />}
          path="/metrics"
        />
        <Route element={<ForeCast />} path="/forecast" />
        <Route element={<Dashboard />} path="/kanban" />
        <Route element={<Client />} path="/client" />
        <Route element={<Port />} path="/port" />
        <Route element={<Country />} path="/country" />
        <Route element={<Province />} path="/province" />
        <Route element={<OriginZone />} path="/origin-zone" />
        <Route element={<ZoneChart />} path="/zone-chart" />
        <Route element={<RateCard />} path="/rate-card-management" exact />
        <Route element={<ZipZone />} path="/zip-zone" />
        <Route element={<Carrier />} path="/carrier" />
        <Route element={<PortLookup />} path="/port-lookup" />
        <Route element={<RateLookup />} path="/rate-lookup" />
        <Route element={<Simulation />} path="/simulation" />
        <Route element={<OrderManagement />} path="/order-management" />
        <Route element={<LateShipPage />} path="/late-ship" />
        <Route
          element={<LostSalesAnalysisPage />}
          path="/lost-sales-analysis"
        />
        <Route element={<ReturnsAnalysisPage />} path="/returns-analysis" />
        <Route
          element={<OrderChannelReviewPage />}
          path="/order-channel-review"
        />
        <Route element={<InventoryAnalysisPage />} path="/inventory-analysis" />
        <Route element={<InventoryHealthPage />} path="/inventory-health" />
        <Route element={<InventoryRiskPage />} path="/inventory-risk" />
        <Route
          element={<PurchaseOrderAnalysisPage />}
          path="/purchase-order-analysis"
        />
        <Route
          element={<SupplyChainCostAnalysisPage />}
          path="/supply-chain-cost-analysis"
        />
        <Route element={<Shipment />} path="/shipment" />
        <Route element={<Shipments />} path="/shipments" />
        <Route element={<ReturnsPage />} path="/returns" />
        <Route element={<TransferOrdersPage />} path="/transfer-orders" />
        <Route element={<ShipmentOptions />} path="/shipment-options" />
        <Route element={<ShippingCost />} path="/shipment-cost" />
        <Route element={<Transaction />} path="/shipment-transaction" />
        <Route element={<Partner />} path="/partner" />
        <Route element={<OrderTracking />} path="/track-order/:id" />
        <Route element={<WeightPackage />} path="/package-maping" />
        <Route element={<ServiceManagement />} path="/service-management" />
        <Route
          element={<OrderTrackingHistory />}
          path="/order-tracking-history/:id"
        />
        <Route element={<Supplier />} path="/supplier" />
        <Route element={<CustomClearance />} path="/custom-clearance" />
        <Route element={<CustomProvider />} path="/custom-provider" />
        <Route element={<FreightBroker />} path="/freight-broker" />
        <Route element={<AccountSettings />} path="/account-setting" />
        <Route element={<AssignUser />} path="/assign-user" />
        <Route
          element={<AlertsAndNotification />}
          path="/alert-and-notification"
        />
        <Route element={<Billing />} path="/billing" />
        <Route element={<EmailTemplateScreen />} path="/email-template" />
        <Route element={<ManagePO />} path="/manage-po" />
        <Route element={<ManageProduct />} path="/manage-product/:id" />
        <Route element={<GlobalNetworkDesign />} path="/network-simulator" />
        <Route element={<TrackingEvents />} path="/tracking-event" />
        <Route element={<Provider />} path="/provider" />
        <Route element={<ProviderEventMapping />} path="/event-mapping" />
        <Route element={<OrderWorkFlow />} path="/order-flow/:id" />
        <Route element={<Events />} path="/events" />
        <Route element={<Rules />} path="/rules" />
        <Route element={<Overpack />} path="/overpack" />
        <Route element={<Manifest />} path="/manifest" />
        <Route element={<ShopifyAppConfig />} path="/shopify-app-config" />
        <Route element={<Pipe17Onboard />} path="/pipe17-onboard" />
        <Route element={<OAuthClient />} path="/oauth-client" />
        <Route element={<Users />} path="/users" />
        <Route element={<Roles />} path="/roles" />
        <Route element={<Sidemenu />} path="/sidemenu" />
        <Route element={<RoleSidemenu />} path="/role-sidemenu" />
        <Route element={<ShippingServiceMap />} path="/shipping-service-map" />
        <Route element={<ShippingService />} path="/shipping-service" />
        <Route element={<BillingTransaction />} path="/transaction" />
        <Route element={<ManagePayment />} path="/manage-payment" />
        <Route element={<UpdateASNForm />} path="/update-asn/:id" />
        <Route element={<CreatePurchaseOrder />} path="/add-asn" />
        <Route element={<Inventory />} path="/inventory" />
        <Route element={<InventoryImport />} path="/inventory-import" />
        <Route element={<HistoricalInventory />} path="/historical-inventory" />
        <Route
          element={<HistoricalInventoryImport />}
          path="/historical-inventory-import"
        />
        <Route
          element={<HistoricalInventorySnapshotHealth />}
          path="/historical-inventory-snapshot-health"
        />
        <Route element={<PurchaseOrder />} path="/purchase-order" />
        <Route element={<AsnTrackingHistory />} path="/asn-tracking/:id" />
        <Route element={<OrderImport />} path="/order-import" />
        <Route
          element={<SalesByCategoryImport />}
          path="/sales-by-category-import"
        />
        <Route element={<CatalogPlanner />} path="/catalog-planner" />
        <Route element={<CatalogPlanner />} path="/catalog-planner/:id" />
        <Route
          element={<CatalogPlanForecast />}
          path="/catalog-planner/:id/forecast/:runId"
        />
        <Route element={<CatalogPlans />} path="/catalog-plans" />
        <Route
          element={<MasterPurchaseOrder />}
          path="/master-purchase-order"
        />
        <Route element={<SupplierClientMap />} path="/supplier-client-map" />
        <Route element={<DropSkipTools />} path="/market-data" />
        <Route element={<ManageMarketData />} path="/manage-market-data/:id" />
        <Route
          element={<MarketDataCalculation />}
          path="/market-data-calculation"
        />
        <Route element={<ManualTracking />} path="/manual-tracking" />
        <Route element={<Kaman />} path="/redefined-copilot" />
        <Route element={<ProductImport />} path="/product-import" />
        <Route element={<SupplierImport />} path="/supplier-import" />
        <Route
          element={<SupplierConfigImport />}
          path="/supplier-config-import"
        />
        <Route
          element={<PurchaseOrderImport />}
          path="/purchase-order-import"
        />
        <Route
          element={<MasterPurchaseOrderImport />}
          path="/master-purchase-order-import"
        />
        <Route element={<ArchiveOrder />} path="/historical-order" />
        <Route element={<ClientConfig />} path="/client-config" />
        <Route element={<AdminConfig />} path="/admin-config" />
        <Route element={<AgentConfig />} path="/agent-config" />
        <Route element={<Catalog />} path="/catalog" />
        <Route element={<ManageCatalog />} path="/manage-catalog/:id" />
        <Route element={<Agent />} path="/agent/:id" />
        <Route element={<CatalogImport />} path="/catalog-import" />
        <Route element={<GeneratedSalesCart />} path="/generate-cart" />
        <Route element={<Customer />} path="/customer" />
        <Route element={<Category />} path="/category" />
        <Route element={<SalesByCategory />} path="/sales-by-category" />
        <Route element={<AddM2O />} path="/m2o-order/:id" />
        <Route element={<ClientOnboard />} path="/client-onboard" />
        <Route element={<Manifest />} path="/manifest" />
        <Route
          element={<ProviderEventMapping />}
          path="/provider-event-mapping"
        />
        <Route element={<CreateOrder />} path="/create-order" />
        <Route element={<AccessLog />} path="/access-log" />
        <Route element={<KafkaDeadLetter />} path="/kafka-dead-letter" />
        <Route element={<InventoryConfigModal />} path="/inventory-config" />
        <Route
          element={<FullyLandedCalculator />}
          path="/fully-landed-calculator"
        />
        <Route element={<ForecastParameter />} path="/forecast-parameter" />
        <Route element={<ParameterValue />} path="/parameter-value/:id" />
        <Route
          element={<ParameterValueImport />}
          path="/parameter-value-import"
        />
        <Route
          element={<M2oOrderTrackingHistory />}
          path="/m2o-order-track/:id"
        />
        <Route element={<Estimator />} path="/estimator" />
        <Route element={<HistoricalShipments />} path="/historical-shipments" />
        <Route element={<ShipmentImport />} path="/shipment-import" />
        <Route
          element={<HistoricalDataImport />}
          path="/historical-data-import"
        />
        <Route element={<NetworkDesign />} path="/network-design" />
        <Route
          element={<ManageNetworkDesign />}
          path="/manage-network-design"
        />
        <Route element={<ViewNetworkDesign />} path="/view-network-design" />
        <Route
          element={<ClientNetworkDesign />}
          path="/client-network-design"
        />
        <Route element={<FulfillmentRule />} path="/fulfilment-rule" />
      </Route>

      <Route element={<LoginPage />} path="/login" />
      <Route element={<PrivacyPolicy />} path="/privacy" />
      <Route element={<ForgotPassword />} path="/forgot-password" />
      <Route element={<ImportProduct />} path="/import-product/:id" />
      <Route element={<OnBoardLogin />} path="/onboard-login" />
      <Route element={<ClientOnboard />} path="/client-onboard" />
    </>
  );
}
